import { render, staticRenderFns } from "./robots.vue?vue&type=template&id=33cfdf8d&"
import script from "./robots.vue?vue&type=script&lang=js&"
export * from "./robots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports